import { ElementRef } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ClipboardService } from 'ngx-clipboard';
import { IRenderRow, TableColumnType } from '../model/model';
import { ServiceService } from '../service/service.service';
import { ISelector } from './selector';

export class ContextMenu {
	contextMenu: MatMenuTrigger;
	contextMenuPosition = { x: '0px', y: '0px' };
	svr: ServiceService;
	selector: ISelector;
	tabData: ElementRef<HTMLTableElement>;
	_clipboardService: ClipboardService;
	dataSource: IRenderRow[];
	columns: TableColumnType[];
	cellSelector(colIndex: number, rowIndex: number): boolean {
		return false;
	}
	openContextMenu(event: MouseEvent, col: number, row: number) {
		if (this.cellSelector(col, row)) {
			event.preventDefault(); // Suppress the browser's context menu
			this.contextMenuPosition = { x: event.clientX + 'px', y: event.clientY + 'px' };
			this.contextMenu.openMenu(); // Open your custom context menu instead
			document
				.getElementsByClassName('cdk-overlay-backdrop')[0]
				.addEventListener('contextmenu', (offEvent: any) => {
					offEvent.preventDefault();
					this.contextMenu.closeMenu();
				});
		}
	}
	onSelCopyClick(hasTitle: boolean) {
		// æ³¨ææååéæ©
		const x = Math.min(this.selector.startX, this.selector.endX);
		const x1 = Math.max(this.selector.startX, this.selector.endX);
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		const text = [];
		if (hasTitle) {
			const line = [];
			for (let ix = x; ix <= x1; ix++) {
				line.push(this.tabData.nativeElement.rows[0].cells[ix].innerText.trim()); // åç°ææ¢è¡ï¼éè¦å»é¤
			}
			text.push(line.join('\t'));
		}
		for (let iy = y; iy <= y1; iy++) {
			const line = [];
			for (let ix = x; ix <= x1; ix++) {
				line.push(this.tabData.nativeElement.rows[iy + 1].cells[ix].innerText.trim());
			}
			text.push(line.join('\t'));
		}

		this._clipboardService.copyFromContent(text.join('\n'));
	}
	onSelLineMenuClick(event: MouseEvent) {
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		this.svr.data.tableRowSelection.select(...this.dataSource.slice(y, y1 + 1).map(v => v.Key));
	}
	onSelCancelLineMenuClick() {
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		this.svr.data.tableRowSelection.deselect(...this.dataSource.slice(y, y1 + 1).map(v => v.Key));
	}
	onSelAllMenuClick() {
		if (this.dataSource.length > 0) {
			this.selector.startX = 1;
			this.selector.startY = 0;
			this.selector.endX = this.columns.length + 1; // å ä¸ªåºå·å
			this.selector.endY = this.dataSource.length - 1;
		}
	}
}
